import { FC } from 'react'

import { createPortal } from 'react-dom'

import ClaimProgressWidget from 'components/ClaimProgressWidgetRender'
import { ClaimWidget as ClaimWidgetRender } from 'components/ClaimWidget'
import { ConnectButton } from 'components/ConnectButton'

export type InitWidgetsProps = {
  elButtonWidget?: HTMLElement
  elClaimWidget?: HTMLElement
  elProgressWidget?: HTMLElement
}

const InitWidgets: FC<InitWidgetsProps> = ({ elButtonWidget, elClaimWidget, elProgressWidget }) => (
  <>
    {elClaimWidget && createPortal(<ClaimWidgetRender />, elClaimWidget)}
    {elButtonWidget && createPortal(<ConnectButton />, elButtonWidget)}
    {elProgressWidget && createPortal(<ClaimProgressWidget />, elProgressWidget)}
  </>
)

export default InitWidgets
